// The values double as the form field name each enemy write posts under.
enum EnemyField {
    Number = "number",
    HitPoints = "hitPoints",
    MaxHitPoints = "maxHitPoints"
}
